import { BOARD_CONFIG, IS_MIX_CATALOG } from "@/config/browserBoard";

/**
 * NEW判定(lastCatalogIds)などカタログ閲覧文脈のboardSlug。
 * `/mix` は同じアンカー板keyでも単板 `/b/{slug}` の文脈と混ざらないよう
 * 別名前空間にする(`#` はslugに使えないため衝突しない)。
 */
export function catalogContextBoardSlug(): string {
  return IS_MIX_CATALOG
    ? `mix#${BOARD_CONFIG.boardKey}`
    : BOARD_CONFIG.boardKey;
}
